import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { DeviationResourceType } from '../../../types/deviation';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import s from './SubscribeToUnlockTooltip.scss';
import { BiData } from '@wix/da-bi/pkg/events';
const TOOLTIP_WIDTH = 144;
const SubscribeToUnlockTooltip = ({ deviation, children, forceVisible, className })=>{
    const { t } = useTranslation();
    const { tier, isTier, isOwner, isUserSubscribed, subscriptionsTabUrl, needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const isSubscribedTier = isTier && !isOwner && isUserSubscribed;
    const isInASubscribedTier = !isTier && !needsSubscription && !isSubscribedButBlocked;
    if (isSubscribedTier || isInASubscribedTier || !(tier === null || tier === void 0 ? void 0 : tier.author)) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    const description = isSubscribedButBlocked ? t('deviation.tier.subscribersOnly.tooltip.lockedSubscribed') : t('deviation.tier.subscribersOnly.tooltip.unsubbed');
    return /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        className: className,
        size: "large",
        width: TOOLTIP_WIDTH,
        placement: "top",
        "aria-label": description,
        description: description,
        isVisible: forceVisible ? true : undefined,
        postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: subscriptionsTabUrl,
            className: s['subs-link'],
            biData: BiData({
                evid: 547,
                referral_info: ReferralType.ACTION_BAR,
                typeid: DeviationResourceType.TIER,
                itemid: tier === null || tier === void 0 ? void 0 : tier.deviationId
            })
        }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink'))
    }, children);
};
SubscribeToUnlockTooltip.displayName = 'SubscribeToUnlockTooltip';
export default SubscribeToUnlockTooltip;
